<template>
    <div id="categories">
        <v-container>
            <v-row class="text-center">
                <v-col cols="12">
                    <h2>Kategorien</h2>
                    <div v-if="categories.length > 0">
                        <ul>
                            <cat-tree v-for="item in categories" :cat="item" :key="item.id" :depth="depth + 1"></cat-tree>
                        </ul>
                    </div>
                    <div v-else>
                        <p>Keine Kategorien vorhanden.</p>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import CatTree from "./CatTree";

    export default {
        name: "Categories",
        components: {
            CatTree
        },
        data() {
            return {
                depth: 0
            }
        },
        computed: {
            ...mapState(['categories']),
        }
    }
</script>

<style scoped>

</style>